import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "global-settings"
    }}>{`Global Settings`}</h1>
    <p>{`Some universal Settings can be found in the option `}<inlineCode parentName="p">{`Global Settings`}</inlineCode>{`. Few Important features can be found there like.`}</p>
    <pre><code parentName="pre" {...{}}>{`- Block Gutter Width
- Block Gutter Height
- PreQuery
- Adaptive Search/ Dynamic Search
- Render Map/SearchBlock as Filter Button in Tab/Mobile View
- The Global Settings panel can be found by clicking this button.
`}</code></pre>
    <p><img alt="GlobalSettings2.png" src={require("../images/GlobalSettings2.png")} />{`
`}<img alt="Global2.png" src={require("../images/Global2.png")} /></p>
    <p>{`The Panel looks like this.`}</p>
    <p><strong parentName="p">{`Block Gutter Width:`}</strong>{` The Width between the available Blocks in px.`}</p>
    <p><strong parentName="p">{`Block Gutter Height:`}</strong>{` The height between the available Blocks in px.`}</p>
    <p><strong parentName="p">{`PreQuery:`}</strong>{` Sometimes the admin wants to show some filtered post in the initial render to the user. This feature PreQuery is exactly what is given for. Initial Posts can be filtered by any selected Taxonomy. Besides this, the filtered posts can also be sorted based on any selected Meta Key or Post Key (post_title, post_date).`}</p>
    <p><strong parentName="p">{`Adaptive Search/ Dynamic Search:`}</strong>{` Using this option you can enable or disable dynamic search. Which is explained in details in `}<a parentName="p" {...{
        "href": "https://www.gitbook.com/book/redq/reactive-pro-advance-searching-filtering/edit#/edit/master/dynamic-search.md?_k=ummpy7"
      }}>{`Dynamic Search`}</a>{` Portion.`}</p>
    <p><img alt="Selection_0011.png" src={require("../images/Selection_0011.jpeg")} /></p>
    <p><strong parentName="p">{`Render Map/SearchBlock as Filter Button in Tab/Mobile View:`}</strong>{` If you enable this feature then in tab and smaller device view you will get button for both geobox and searchblock. then after clicking the button you will see the map or the searchblock.`}</p>
    <p>{`In Tab view the button will look something like this:`}</p>
    <p><img alt="Selection_005.png" src={require("../images/Selection_005.jpeg")} /></p>
    <p>{`After clicking the `}<inlineCode parentName="p">{`Filter Search button`}</inlineCode>{` you will see something like this:`}</p>
    <p><img alt="Selection_0061.png" src={require("../images/Selection_0061.jpeg")} /></p>
    <p>{`After making the changes the Admin can either Save by clicking the save button or can cancel.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      